import React, { useEffect, useState, useContext } from "react";
import MenuAdmin from "../navAdmin/Menu";
import Footer from "../../footer/Footer";
import Information from "../../public/Information/Information";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { CurrentUserContext } from "../../../App";
import MapOperationRoom from "../../public/Information/MapOperationRoom";

function InformationMap() {
  const { setIsMessage } = useContext(CurrentUserContext);
  let params = useParams();
  const [role] = useState(JSON.parse(localStorage.getItem("user")));
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!role.auth.role.includes("ADMIN")) {
      setIsMessage({ type: "warning", data: "ปฏิเสธเข้าถึงข่าวประชาสัมพันธ์" });
      navigate("/admin");
    }
  }, []);
  return (
    <>
      <MenuAdmin menuActive={"mangePetition"} />
      <MapOperationRoom role={"admin"} />
    </>
  );
}

export default InformationMap;
